<!--
Copyright 2022 LINE Fukuoka Corporation

LINE Corporation licenses this file to you under the Apache License,
version 2.0 (the "License"); you may not use this file except in compliance
with the License. You may obtain a copy of the License at:

  https://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
License for the specific language governing permissions and limitations
under the License.
-->
<template>
  <v-radio-group v-model="radio" :rules="[validateRequired]">
    <v-radio
      v-for="(sectionOption, index) in sectionOptions"
      :key="index"
      :label="sectionOption.option.value"
      :value="sectionOption.option.value"
      style="display: flex"
      @click="radioClick"
      :disabled="disabled"
    ></v-radio>
  </v-radio-group>
</template>

<script>
import Vue from "vue";
import InputBase from "./InputBase.vue";

export default Vue.extend({
  name: "InputChoiceGroupheader",
  mixins: [InputBase],
  props: {
    isLiffMode: Boolean,
    isAdminMode: Boolean,
  },
  created() {
    var params = Object.assign(
      {
        sectionOptions: [],
        isRequired: { value: false },
        isRequiredForUser: { value: false },
        input: undefined,
      },
      this.params
    );

    this.itemKey = this.params.itemKey;
    this.sectionOptions = params.sectionOptions;
    this.required = params.isRequired.value;
    this.isRequiredForUser = params.isRequiredForUser.value;
    this.radio = params.input;
    this.dropdown = params.input;
  },
  methods: {
    getValue() {
      return this.radio;
    },
    validateRequired() {
      const isValid = this.radio !== undefined;
      if (this.isAdminMode) {
        return !this.required || isValid;
      } else if (this.isLiffMode) {
        return (!this.required && !this.isRequiredForUser) || isValid;
      }
    },
    radioClick() {
      this.$emit(
        "choice-groupheader-radio-click",
        this.getValue(),
        this.params
      );
    },
  },
});
</script>
